import { queryOptions } from '@tanstack/react-query'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

import { Subscription, SubscriptionType } from '../domain/subscription'

const client = new Client(getConfig().PUBLIC_API_ENDPOINT ?? '')

type GetSubscriptionsResult = {
  items: Subscription[]
  pageSize: number
  page: number
  totalItems: number
}

export const getSubscriptions = async (): Promise<Subscription[]> => {
  const result = await client.get<GetSubscriptionsResult>('/events-api/subscriptions')
  return result.items
}

export type DeleteSubscriptionProps = {
  subscriptionId: string
}

export const deleteSubscription = async (props: DeleteSubscriptionProps): Promise<void> => {
  await client.delete(`/events-api/subscriptions/${props.subscriptionId}`)
}

export type CreateSubscriptionProps = {
  data: {
    eventTypes: SubscriptionType[]
    url: string
    name: string
    description?: string
  }
}

export type CreateSubscriptionResult = Subscription

export const createSubscription = async (props: CreateSubscriptionProps): Promise<CreateSubscriptionResult> => {
  return await client.post<CreateSubscriptionResult>('/events-api/subscriptions', props.data)
}

export const subscriptionsQueryOptions = () =>
  queryOptions({
    queryKey: ['subscriptions'],
    queryFn: getSubscriptions,
  })
